import { useCallback, useEffect, useState } from 'react';

export default function useAsync(load, deps) {
  const [state, setState] = useState({ loading: true, error: null, data: undefined });
  const [attempt, setAttempt] = useState(0);
  const reload = useCallback(() => setAttempt((n) => n + 1), []);
  useEffect(() => {
    let active = true;
    setState((s) => ({ ...s, loading: true, error: null }));
    load()
      .then((data) => active && setState({ loading: false, error: null, data }))
      .catch((error) => {
        console.error(error);
        if (active) setState({ loading: false, error, data: undefined });
      });
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, attempt]);
  return { ...state, reload };
}
